module.exports = __webpack_public_path__ + "static/media/business.70db5d2a.svg";